module.exports = __webpack_public_path__ + "a1bc56b2927e4af182110be47ffa387b.png";